import {notificationCenterService} from "../services/notificationCenterService";
import {frontageApiService} from "@/plugins/frontage-api";
import Vue from "vue";
const debouncer = require('just-debounce');

const state = {
  isNewCounter: 0,
  notifications: []
}

const getters = {
  getIsNewCounter: state => state.isNewCounter,
  getNotifications: state => state.notifications,
  getUnreadNotifications: state => state.notifications.filter((notification) => !notification.read)
}

const mutations = {
  setIsNewCounter(state, counter) {
    state.isNewCounter = counter
  },
  setNotifications(state, notifications) {
    state.notifications = notifications
  },
  setNotificationStatus(state, {payload}){
    let notificationIdx = state.notifications.findIndex((notification) => notification.uid === payload.notification_uid)
    if (notificationIdx < 0) return
    let notification = state.notifications[notificationIdx]
    Vue.set(notification, 'read', !notification.read)
  },
  setAllRead(state){
    state.notifications.forEach(notification => {
      Vue.set(notification, 'read', true)
    })
  }
}

const actions = {
  async initNotificationCenterBadge({dispatch}){
    try {
      frontageApiService.listen('is-new-notification-counter-reset', () => dispatch('resetNotificationCounter'));
      await dispatch('fetchNotificationsCounterLongPolling')
    } catch (e) {
      console.error('error', e);
    }
  },

  async setNotificationReadStatus({commit, state, dispatch}, payload){
    try {
      await notificationCenterService.setNotificationReadStatus(payload.notification_uid, payload.status)
      commit('setNotificationStatus', {payload})
    } catch (e) {
      console.error('error', e)
    }
  },

  async setAllNotificationsAsRead({commit}){
    try {
      await notificationCenterService.setAllNotificationsAsRead()
      commit('setAllRead')
    }
    catch (e){
      console.error('error', e)
    }
  },

  async fetchNotificationsCounterLongPolling({commit, dispatch}){
    notificationCenterService.cancelRequest()

    try {
      let isNewCounter = (await notificationCenterService.getIsNewNotificationCounter(state.isNewCounter))
      frontageApiService.send('is-new-notification-counter-update', isNewCounter);
      commit('setIsNewCounter', isNewCounter)
    } catch (e) {
      console.error('error', e);
    } finally {
      await new Promise(resolve => setTimeout(resolve, 500));
      await dispatch('notificationsCenterLongPollDebouncer')
    }
  },

  async resetNotificationCounter({commit}){
    try {
      await notificationCenterService.resetNotificationCounter()
      let isNewCounter = 0
      frontageApiService.send('is-new-notification-counter-update', isNewCounter);
      commit('setIsNewCounter', isNewCounter)
    } catch (e) {
      console.error('error', e)
    }
  },

  async fetchNotifications({commit}){
    try {
      let currentType = null
      let typeName = null
      const allTypes = await notificationCenterService.getNotificationsTypes()
      const allMetadata = await notificationCenterService.getNotificationsMetadata()
      const allNotifications = await notificationCenterService.getNotifications(30)

      let mappedNotifications = allNotifications.map(notification => {
        const currentMetadata = allMetadata.find( metadata => metadata.uid === notification.notification_metadata_uid)
        if (currentMetadata && currentMetadata.notification_type_uid)
          currentType = allTypes.find( type => type.uid === currentMetadata.notification_type_uid)
        if (currentType && currentType.name) typeName = currentType.name
        return {...notification, ...{
            notification_type : typeName,
            notification_code_name : currentMetadata.notification_code_name,
            creator_type : currentMetadata.creator_type,
            creator_identifier : currentMetadata.creator_identifier,
            avatarImage: notificationCenterService.getAvatarByType(typeName),
            pane: currentMetadata.pane
          }}
      })
      mappedNotifications = mappedNotifications.filter(notification => notification.pane)
      commit('setNotifications', mappedNotifications)
    } catch (e) {
      console.error('error', e)
    }
  },

  notificationsCenterLongPollDebouncer({dispatch}) {
    // if (!this.conversationIsActive) return
    debouncer(dispatch('fetchNotificationsCounterLongPolling'),1000);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
